import createReducer from 'reducers/createReducer';

import { ClientStatusList } from 'actions/actionTypes';

import { ArrayConcat } from 'utils/functions';

const INITIAL_STATE = {
    searchFilter: {
        sort: '0',
    },
    data: [],
    coursePlanId: [],
    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    // 이벤트
    [ClientStatusList.CHANGE_CLIENT_STATUS_SEARCH_FILTER]: (state, action) => {
        if (action.payload.type === 'checkbox') {
            if (action.payload.name === 'sort') {
                state.searchFilter[action.payload.name] = action.payload.value;
            } else {
                state.searchFilter[action.payload.name] = ArrayConcat(
                    Array.from(state.searchFilter[action.payload.name]),
                    action.payload.value
                );
            }
        } else {
            state.searchFilter[action.payload.name] = action.payload.value;
        }
    },

    // 클라이언트 현황 목록
    [ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST]: (state, action) => {
        // state.data = INITIAL_STATE.data;
        state.error = INITIAL_STATE.error;
    },
    [ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST_SUCCESS]: (
        state,
        action
    ) => {
        state.data = action.payload.clients;
        state.coursePlanId = action.payload.clients.filter((client)=>client.coursePlanId === "1" || client.coursePlanId === "2" || client.coursePlanId === "100");
    },
    [ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST_FAILURE]: (
        state,
        action
    ) => {
        state.error = {
            triggered: true,
            message: action.payload?.errorMessage,
        };
    },

    // 단일 클라이언트 업데이트
    [ClientStatusList.CHANGE_CLIENT_STATUS] : (state, action) => {
        const updateClient = state.data.filter((item) => item.clientGuid === action.payload.clientGuid);
        updateClient[0][action.payload.name] =  action.payload.value;
    },
});

export default reducer;
